/* Chart timeline panel (W2-03): the host fills the panel. Tokens only. */

.panel {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--color-bg);
}

.panel:focus-visible,
.panel [data-tl-col]:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-focus-ring);
  outline-offset: calc(-1 * var(--focus-ring-width));
}

.host {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
}

.empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
